import { render, staticRenderFns } from "./VerificationButtons.vue?vue&type=template&id=257d4502"
import script from "./VerificationButtons.vue?vue&type=script&lang=js"
export * from "./VerificationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports